import { useEffect, useState } from "react";
import { isSolidColorImage } from "../Services/helper";
import { useTranslation } from "react-i18next";

const DisplayService = ({ setSelectedService, service,serviceId,setIsMap }) => {
  const [showBg, setShowBg] = useState(true);
  useEffect(() => {
    (async () => {
      const res = await isSolidColorImage(service.imageUrl, 90);
      if (res?.isSolidColor) {
        setShowBg(false);
      }
    })();
  }, [service.imageUrl]);

  return (
    <div
      className={` 
                max-w-[202rem] 
                sm:w-[24rem] 
                md:w-[20rem] 
                lg:w-[18rem]
                lg:h-[21rem]
                xl:w-[20rem]
                xl:h-[25rem]
                2xl:h-[30rem] 2xl:w-[25rem]h-56
                relative bg-cover bg-no-repeat bg-center rounded-lg shadow-lg hover:shadow-xl transition
                ${service?.serviceType==="Points of Interests"||serviceId===4?'cursor-pointer':'cursor-default'}
            `}

      style={{
        backgroundImage: `url(${service.imageUrl})`,
      }}
      onClick={() => {
        setSelectedService(service.link);
        setIsMap(service?.serviceType==="Points of Interests"||service?.serviceTypeId===4);
      }}
    >
      {showBg && (
        <div className="absolute inset-0 bg-black/40 rounded-lg z-0" />
      )}
      <div className={`flex items-center justify-center h-full relative z-10`}>
        <h3 className="text-center text-white bg-black/50 p-2 text-[clamp(1rem,2vw,1.5rem)] font-semibold align-center items-center w-fit min-w-[70%] px-2 rounded-md">
          {service.title}
        </h3>
      </div>
    </div>
  );
};

export const VerticalServices = ({ terminalData, setSelectedService,setIsMap }) => {
  const { t } = useTranslation();
  if (!terminalData?.services.length) return;
  return (
    <div className="w-full p-6 ">
      <div className="text-center font-bold text-3xl mb-6">
        {terminalData?.serviceLabel || t("servicesLabel")}
      </div>
      <div className="flex flex-wrap justify-center gap-4 p-4 mx-w-2xl m-auto">
        {terminalData?.services?.map((service, idx) => (
          <DisplayService
            service={service}
            key={idx}
            setSelectedService={setSelectedService}
            setIsMap={setIsMap}
            serviceId={service?.serviceTypeId}
          />
        ))}
      </div>
    </div>
  );
};

export const VerticalQrCodes = ({ terminalData }) => {
  if (!terminalData?.qrCodes.length) return;
  return (
    <div className="w-full p-6">
      <div className="text-center font-bold text-3xl mb-6">
        {terminalData?.qrCodeLabel || "QR Codes"}
      </div>
      <div className="flex flex-wrap gap-6 w-full justify-center">
        {terminalData?.qrCodes?.map((qr, idx) => (
          <div
            key={idx}
            className={`relative rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center 
                                "max-w-[202rem] sm:w-[24rem] 
                                md:w-[20rem] 
                                lg:w-[15rem]
                                lg:h-[19rem]
                                xl:w-[20rem]
                                xl:h-[25rem]
                                2xl:h-[27rem] 
                                2xl:w-[24rem]
                                3xl:h-[50rem]
                                h-56"
                                `}
            style={{
              backgroundImage: `url(${qr.backgroundImageUrl})`,

              backgroundColor: qr.backgroundColor,
            }}
          >
            <div className="absolute inset-0 bg-black/40 rounded-lg z-0" />

            <div className="flex flex-col justify-between h-full relative z-10">
              <h3 className="text-center text-black bg-white/70 p-2 text-xl 3xl:text-[4rem] font-semibold w-fit mt-4 min-w-[50%] rounded -[5px]">
                {qr.title}
              </h3>

              <div
                className={`
                                    self-end 
                                    w-32 h-36 
                                    xl:w-[8rem] xl:h-[8rem] 
                                    2xl:w[12rem] 2xl:h-[12rem]
                                    bg-white  rounded-lg mt-2 bg-contain bg-center`}
                style={{
                  backgroundImage: `url(${qr.imageUrl})`,

                  backgroundSize: "contain",

                  backgroundPosition: "center",

                  backgroundRepeat: "no-repeat",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};